/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2021-03-09 00:00:00
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Modal, TextContainer, TextStyle } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import _ from 'lodash';
import { connect } from 'react-redux';
import { AppNameShow, AppTypeOnlyAutoOnV3 } from 'src/constants/integration';

type Props = {
  active: boolean,
  handleChange: () => void,
  handleContinue: () => void
};

type ComposedProps = Props & WithI18nProps;

class RemoveAppIntegrationModal extends Component<ComposedProps> {
  render() {
    const { i18n, active, loading, currentAppIntegrationName, appType } = this.props;
    const isOnlyAutoOnV3 = AppTypeOnlyAutoOnV3.includes(appType);

    const generalContenModalV2AndV3 = () => {
      return i18n.translate('AdminHTML.Integration.RemoveAppIntegration.content', {
        t1: (
          <strong>{i18n.translate('AdminHTML.Integration.RemoveAppIntegration.content_t1')}</strong>
        ),
        t2: (
          <strong>{i18n.translate('AdminHTML.Integration.RemoveAppIntegration.content_t2')}</strong>
        ),
        t3: <strong>{AppNameShow[currentAppIntegrationName]}</strong>,
        t4: (
          <strong>{i18n.translate('AdminHTML.Integration.RemoveAppIntegration.content_t4')}</strong>
        ),
        t5: (
          <strong>{i18n.translate('AdminHTML.Integration.RemoveAppIntegration.content_t5')}</strong>
        )
      });
    };

    const generalContenModalOnlyV3 = () => {
      return (
        <div>
          <p>
            {i18n.translate('AdminHTML.Integration.RemoveAppIntegration.contentV3', {
              t1: (
                <strong>
                  {i18n.translate('AdminHTML.Integration.RemoveAppIntegration.content_t1')}
                </strong>
              ),
              t2: (
                <strong>
                  {i18n.translate('AdminHTML.Integration.RemoveAppIntegration.content_t2')}
                </strong>
              ),
              t3: <strong>{AppNameShow[currentAppIntegrationName]}</strong>,
              t4: (
                <strong>
                  {i18n.translate('AdminHTML.Integration.RemoveAppIntegration.contentV3_t4')}
                </strong>
              ),
              t5: (
                <strong>
                  {i18n.translate('AdminHTML.Integration.RemoveAppIntegration.contentV3_t5')}
                </strong>
              ),
              t6: (
                <strong>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://help.boostcommerce.net/collection/261-app-integration">
                    here
                  </a>
                </strong>
              )
            })}
          </p>
          <br />
          <p>{i18n.translate('AdminHTML.Integration.RemoveAppIntegration.contentV3_2')}</p>
        </div>
      );
    };

    const generalContenModal = () => {
      if (isOnlyAutoOnV3) return generalContenModalOnlyV3();

      return generalContenModalV2AndV3();
    };

    return (
      <Modal
        large
        open={active}
        onClose={this.handleChange}
        title={i18n.translate('AdminHTML.Integration.RemoveAppIntegration.title')}
        primaryAction={{
          destructive: true,
          loading,
          content: i18n.translate('AdminHTML.Common.Action.remove'),
          onAction: this.handleContinue
        }}
        secondaryActions={[
          {
            content: i18n.translate('AdminHTML.Common.Action.cancel'),
            onAction: this.handleChange
          }
        ]}>
        <Modal.Section>
          <TextContainer>
            <TextStyle>{generalContenModal()}</TextStyle>
          </TextContainer>
        </Modal.Section>
      </Modal>
    );
  }

  handleChange = () => {
    this.props.handleChange();
  };

  handleContinue = () => {
    this.props.handleContinue();
  };
}

const mapStateToProps = (state, props) => {
  const appType = _.get(state.appIntegration, 'removeAppType', '');
  const currentAppIntegration = _.get(state.oauth.tenantApp, 'currentAppIntegration', {});

  return {
    currentAppIntegrationName: currentAppIntegration[appType],
    appType
  };
};

export default withI18n()(connect(mapStateToProps)(RemoveAppIntegrationModal));
